import { render, staticRenderFns } from "./AddBankPopup.vue?vue&type=template&id=2f7dec97&scoped=true&"
import script from "./AddBankPopup.vue?vue&type=script&lang=js&"
export * from "./AddBankPopup.vue?vue&type=script&lang=js&"
import style0 from "./AddBankPopup.vue?vue&type=style&index=0&id=2f7dec97&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2f7dec97",
  null
  
)

export default component.exports